// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__euCN0.styles_ocean-50__4fCAC {
  color: #e6f2ff;
}

.styles_color__euCN0.styles_ocean-100__iGVXc {
  color: #e6f2ff;
}

.styles_color__euCN0.styles_ocean-200__Fk7Q3 {
  color: #b3daff;
}

.styles_color__euCN0.styles_ocean-300__X3TYE {
  color: #7abfff;
}

.styles_color__euCN0.styles_ocean-400__sYyzG {
  color: #2392fb;
}

.styles_color__euCN0.styles_ocean-500__IHn-k {
  color: #0074e0;
}

.styles_color__euCN0.styles_ocean-600__ch42X {
  color: #043571;
}

.styles_color__euCN0.styles_space-50__6nubT {
  color: #f0f0f0;
}

.styles_color__euCN0.styles_space-100__pZOS9 {
  color: #e3e3e3;
}

.styles_color__euCN0.styles_space-200__cuXYE {
  color: #bfbfbf;
}

.styles_color__euCN0.styles_space-300__94dMR {
  color: gray;
}

.styles_color__euCN0.styles_space-400__-pvL- {
  color: #616161;
}

.styles_color__euCN0.styles_space-500__jLCWj {
  color: #283439;
}

.styles_color__euCN0.styles_gray-50__Bn40W {
  color: #eff3f6;
}

.styles_color__euCN0.styles_gray-100__0o14M {
  color: #e6ecef;
}

.styles_color__euCN0.styles_gray-200__qQKFc {
  color: #cfd8de;
}

.styles_color__euCN0.styles_gray-300__iezEP {
  color: #a8b9c2;
}

.styles_color__euCN0.styles_gray-400__ls\\+ft {
  color: #7e98a5;
}

.styles_color__euCN0.styles_gray-500__uUdGo {
  color: #738f9c;
}

.styles_color__euCN0.styles_green-50__lVns0 {
  color: #e3fdf6;
}

.styles_color__euCN0.styles_green-100__RUBY8 {
  color: #c5f6ea;
}

.styles_color__euCN0.styles_green-200__LMK6u {
  color: #69ddc2;
}

.styles_color__euCN0.styles_green-300__sZJK1 {
  color: #45bfa3;
}

.styles_color__euCN0.styles_green-400__RKwlr {
  color: #1cab8a;
}

.styles_color__euCN0.styles_green-500__ksQZh {
  color: #128268;
}

.styles_color__euCN0.styles_red-50__fD5do {
  color: #fff0f3;
}

.styles_color__euCN0.styles_red-100__Mv\\+NG {
  color: #f9d2db;
}

.styles_color__euCN0.styles_red-200__WGXXh {
  color: #f8b4c4;
}

.styles_color__euCN0.styles_red-300__E2ben {
  color: #e85e81;
}

.styles_color__euCN0.styles_red-400__9fQXs {
  color: #e23661;
}

.styles_color__euCN0.styles_red-500__SOboz {
  color: #b82348;
}

.styles_color__euCN0.styles_yellow-50__PSwy8 {
  color: #fffae6;
}

.styles_color__euCN0.styles_yellow-100__e1pD2 {
  color: #fff0b3;
}

.styles_color__euCN0.styles_yellow-200__KDpT8 {
  color: #ffe380;
}

.styles_color__euCN0.styles_yellow-300__QnN3C {
  color: #ffcf57;
}

.styles_color__euCN0.styles_yellow-400__vtvaL {
  color: #ffc60a;
}

.styles_color__euCN0.styles_yellow-500__Hovlr {
  color: #ffb700;
}

.styles_color__euCN0.styles_orange-50__Oy4Kc {
  color: #fff2eb;
}

.styles_color__euCN0.styles_orange-100__UZgjC {
  color: #ffe4d6;
}

.styles_color__euCN0.styles_orange-200__PpT3B {
  color: #ffc69e;
}

.styles_color__euCN0.styles_orange-300__JBw7o {
  color: #ffa047;
}

.styles_color__euCN0.styles_orange-400__7C0-v {
  color: #ff7b42;
}

.styles_color__euCN0.styles_orange-500__0HqcN {
  color: #ee4920;
}

.styles_color__euCN0.styles_turquoise-50__DV7Wx {
  color: transparent;
}

.styles_color__euCN0.styles_turquoise-100__vh5XI {
  color: #e6fcff;
}

.styles_color__euCN0.styles_turquoise-200__NUnDv {
  color: #b3f5ff;
}

.styles_color__euCN0.styles_turquoise-300__4o8it {
  color: #78e2f2;
}

.styles_color__euCN0.styles_turquoise-400__jTXZ8 {
  color: #00c7e6;
}

.styles_color__euCN0.styles_turquoise-500__LmPjy {
  color: transparent;
}

.styles_color__euCN0.styles_turquoise-600__wDhj7 {
  color: transparent;
}

.styles_color__euCN0.styles_violet-50__0yyLn {
  color: #eae6ff;
}

.styles_color__euCN0.styles_violet-100__0Jq9L {
  color: #d9d1ff;
}

.styles_color__euCN0.styles_violet-200__JtQAK {
  color: #bfb3ff;
}

.styles_color__euCN0.styles_violet-300__ELPe1 {
  color: #9d90ea;
}

.styles_color__euCN0.styles_violet-400__vmGjW {
  color: #8678d9;
}

.styles_color__euCN0.styles_violet-500__UtriA {
  color: #6f5ccc;
}

.styles_color__euCN0.styles_snow-50__3esHl {
  color: white;
}

.styles_color__euCN0.styles_snow-100__1CjcL {
  color: #f7f7f7;
}

.styles_color__euCN0.styles_snow-200__WMB7L {
  color: #f0efef;
}

.styles_color__euCN0.styles_snow-300__gWajE {
  color: #e6e6e6;
}

.styles_color__euCN0.styles_snow-400__gejV5 {
  color: #e1e0e0;
}

.styles_color__euCN0.styles_snow-500__brwBZ {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__-bg0K.styles_ocean__Kxc82 {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__-bg0K.styles_ocean-light__o-0UQ {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__-bg0K.styles_green__YYOX0 {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__-bg0K.styles_green-light__nYHul {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__-bg0K.styles_red__NErzb {
  background-color: #e23661;
  color: white;
}

.styles_background-color__-bg0K.styles_red-light__Ffq-6 {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__-bg0K.styles_orange__j2bv9 {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__-bg0K.styles_orange-light__LgHQM {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__-bg0K.styles_space__\\+w17E {
  background-color: #616161;
  color: white;
}

.styles_background-color__-bg0K.styles_space-light__Re\\+\\+8 {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__-bg0K.styles_gray-light__Y0mNm {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__-bg0K.styles_violet__4\\+E8l {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__-bg0K.styles_violet-light__z20f9 {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__-bg0K.styles_yellow__qIqPY {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__-bg0K.styles_yellow-light__bgZXf {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__QxD9S .styles_buttons__XJbmw {
  margin-left: 16px ;
}
.styles_root__QxD9S .styles_videoBackground__yfY35 {
  background-color: white;
}
.styles_root__QxD9S .styles_visible__OSZ3M {
  opacity: 1 !important;
}
.styles_root__QxD9S .styles_draggable__HGaAv {
  bottom: 20px;
  right: 20px;
}
.styles_root__QxD9S .styles_recordingIndicator__aW8LJ {
  pointer-events: none;
}
.styles_root__QxD9S .styles_header__Yr2vi .styles_recordingIndicator__aW8LJ {
  margin-left: 32px ;
}
.styles_root__QxD9S .styles_minimizedVideo__tX-uU {
  align-items: center;
  background-color: white;
  border: 2px solid #616161;
  border-radius: 8px;
  display: flex;
  height: 130px;
  justify-content: center;
  width: 214px;
  z-index: 1650;
}
@media (min-width: 960px) {
  .styles_root__QxD9S .styles_minimizedVideo__tX-uU {
    height: 220px;
    width: 350px;
  }
}
.styles_root__QxD9S .styles_minimizedVideo__tX-uU > * {
  position: absolute;
}
.styles_root__QxD9S .styles_minimizedVideo__tX-uU > video {
  border-radius: 8px;
  height: 100%;
  object-fit: cover;
  width: 100%;
}
.styles_root__QxD9S .styles_minimizedVideo__tX-uU .styles_wrapper__lMcwb {
  background-color: #e6ecef;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  opacity: 0;
  padding: 16px 0px ;
  transition: all linear 0.4s;
  transition-delay: 0.4s;
  width: 100%;
}
.styles_root__QxD9S .styles_minimizedVideo__tX-uU .styles_wrapper__lMcwb:hover {
  background-color: rgba(230, 236, 239, 0.5);
  opacity: 1;
  transition: all linear 0.4s;
}
.styles_root__QxD9S .styles_minimizedVideo__tX-uU .styles_wrapper__lMcwb .styles_draggableFirstButtons__j\\+F7W {
  display: flex;
  justify-content: space-between;
  padding: 0 16px ;
}
.styles_root__QxD9S .styles_rootActive__kqlXV {
  background-color: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1600;
}
.styles_root__QxD9S .styles_header__Yr2vi {
  align-items: center;
  background-color: white;
  box-shadow: 0 3px 5px rgba(9, 30, 66, 0.2), 0 0 1px rgba(9, 30, 66, 0.31);
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 8px 16px ;
  width: 100%;
  z-index: 1;
}
@media (max-width: 959.95px) {
  .styles_root__QxD9S .styles_header__Yr2vi {
    justify-content: flex-start;
  }
}
@media (max-width: 959.95px) {
  .styles_root__QxD9S .styles_header__Yr2vi .styles_smHidden__-7pcg {
    display: none;
  }
}
.styles_root__QxD9S .styles_header__Yr2vi .styles_iconBack__nsul8 {
  display: none;
}
@media (max-width: 959.95px) {
  .styles_root__QxD9S .styles_header__Yr2vi .styles_iconBack__nsul8 {
    display: initial;
    font-size: 30px;
  }
}
@media (max-width: 959.95px) {
  .styles_root__QxD9S .styles_header__Yr2vi .styles_timer__7kEEh {
    display: none;
  }
}
.styles_root__QxD9S .styles_center__2lTbX {
  align-items: center;
  background-color: #f7f7f7;
  box-sizing: border-box;
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
  width: 100%;
}
.styles_root__QxD9S .styles_center__2lTbX .styles_primaryVideo__cDLdu {
  height: 100%;
  position: absolute;
  width: 100%;
}
.styles_root__QxD9S .styles_center__2lTbX .styles_largeAvatarWithBorder__QiJXk {
  border-color: white;
}
.styles_root__QxD9S .styles_secondaryVideos__RVR8S {
  bottom: 0;
  position: absolute;
  right: 24px ;
}
.styles_root__QxD9S .styles_secondaryVideos__RVR8S > div {
  align-items: center;
  background-color: white;
  border: 2px solid #616161;
  border-radius: 8px;
  display: flex;
  height: 146px;
  justify-content: center;
  width: 104px;
  z-index: 1650;
  margin-bottom: 24px ;
}
@media (min-width: 960px) {
  .styles_root__QxD9S .styles_secondaryVideos__RVR8S > div {
    height: 220px;
    width: 350px;
  }
}
.styles_root__QxD9S .styles_secondaryVideos__RVR8S > div > * {
  position: absolute;
}
.styles_root__QxD9S .styles_secondaryVideos__RVR8S > div > video {
  border-radius: 8px;
  height: 100%;
  object-fit: cover;
  width: 100%;
}
.styles_root__QxD9S .styles_secondaryVideos__RVR8S > div > video {
  object-fit: contain;
  position: relative;
}
.styles_root__QxD9S .styles_secondaryVideos__RVR8S > div.styles_localPreview__ch-mM > video {
  transform: scaleX(-1);
}
.styles_root__QxD9S .styles_panel__6eWuf {
  align-items: center;
  background-color: white;
  box-shadow: 0 3px 5px rgba(9, 30, 66, 0.2), 0 0 1px rgba(9, 30, 66, 0.31);
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 8px 16px ;
  position: relative;
  width: 100%;
  z-index: 1;
}
.styles_root__QxD9S .styles_panel__6eWuf .styles_toggleButton__PLNKX {
  font-weight: 400;
  font-size: 1rem;
  letter-spacing: -0.09px;
  line-height: 20px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  align-items: center;
  color: #616161;
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 16px ;
}
.styles_root__QxD9S .styles_panel__6eWuf .styles_recordStopButton__PWPly {
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/components/chat/voip-panel/active-call-box/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_media-query.scss","webpack://./src/ui-kit/styles/_theme/_typography.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADeI;EACI,kBAAA;AA6SR;AA1SI;EACI,uBAAA;AA4SR;AAzSI;EACI,qBAAA;AA2SR;AAxSI;EACI,YAAA;EACA,WAAA;AA0SR;AAvSI;EACI,oBAAA;AAySR;AAtSI;EACI,kBAAA;AAwSR;AArSI;EArDA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAiDyB;EAhDzB,uBAAA;EACA,YA+CgC;EA9ChC,aAAA;AA6VJ;AElVY;EFkCR;IA1CI,aAAA;IACA,YAAA;EA8VN;AACF;AA5VI;EACI,kBAAA;AA8VR;AA3VI;EACI,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AA6VR;AA5TQ;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,sBAAA;EACA,WAAA;AA8TZ;AA5TY;EACI,0CAAA;EACA,UAAA;EACA,2BAAA;AA8ThB;AA3TY;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AA6ThB;AAxTI;EACI,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;AA0TR;AAvTI;EACI,mBAAA;EACA,uBAAA;EACA,yEAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAyTR;AE/WY;EF4CR;IAaQ,2BAAA;EA0TV;AACF;AEpXY;EF4DJ;IAEQ,aAAA;EA0Td;AACF;AAvTQ;EACI,aAAA;AAyTZ;AE5XY;EFkEJ;IAIQ,gBAAA;IACA,eAAA;EA0Td;AACF;AElYY;EF2EJ;IAEQ,aAAA;EAyTd;AACF;AArTI;EACI,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAuTR;AArTQ;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AAuTZ;AApTQ;EACI,mBAAA;AAsTZ;AAlTI;EACI,SAAA;EACA,kBAAA;EACA,YAAA;AAoTR;AAlTQ;EAhKJ,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,aA4J6B;EA3J7B,uBAAA;EACA,YA0JoC;EAzJpC,aAAA;EA2JQ,oBAAA;AA2TZ;AE3cY;EF6IJ;IArJA,aAAA;IACA,YAAA;EAudN;AACF;AArdI;EACI,kBAAA;AAudR;AApdI;EACI,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AAsdR;AAvUQ;EACI,mBAAA;EACA,kBAAA;AAyUZ;AAtUQ;EACI,qBAAA;AAwUZ;AApUI;EACI,mBAAA;EACA,uBAAA;EACA,yEAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAsUR;AApUQ;EG5IJ,gBAAA;EANA,eAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EH8Lb,mBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AAyUZ;AAtUQ;EACI,kBAAA;AAwUZ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n@mixin small-video($height, $width) {\n    align-items: center;\n    background-color: theme.color(snow-50);\n    border: 2px solid theme.color(space-400);\n    border-radius: theme.get-border-radius(lg);\n    display: flex;\n    height: $height;\n    justify-content: center;\n    width: $width;\n    z-index: theme.get-z-index(call-screen-video);\n\n    @include theme.mq-up(md) {\n        height: 220px;\n        width: 350px;\n    }\n\n    > * {\n        position: absolute;\n    }\n\n    > video {\n        border-radius: theme.get-border-radius(lg);\n        height: 100%;\n        object-fit: cover;\n        width: 100%;\n    }\n}\n\n.root {\n    .buttons {\n        margin-left: theme.spacing(2);\n    }\n\n    .videoBackground {\n        background-color: theme.color(snow-50);\n    }\n\n    .visible {\n        opacity: 1 !important;\n    }\n\n    .draggable {\n        bottom: 20px;\n        right: 20px;\n    }\n\n    .recordingIndicator {\n        pointer-events: none;\n    }\n\n    .header .recordingIndicator {\n        margin-left: theme.spacing(4);\n    }\n\n    .minimizedVideo {\n        @include small-video(130px, 214px);\n\n        .wrapper {\n            background-color: theme.color(gray-100);\n            border-radius: theme.get-border-radius(lg);\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n            justify-content: space-between;\n            opacity: 0;\n            padding: theme.spacing(2, 0);\n            transition: all linear 0.4s;\n            transition-delay: 0.4s;\n            width: 100%;\n\n            &:hover {\n                background-color: hsla(200, 21%, 92%, 0.5);\n                opacity: 1;\n                transition: all linear 0.4s;\n            }\n\n            .draggableFirstButtons {\n                display: flex;\n                justify-content: space-between;\n                padding: 0 theme.spacing(2);\n            }\n        }\n    }\n\n    .rootActive {\n        background-color: theme.color(snow-50);\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        left: 0;\n        position: fixed;\n        top: 0;\n        width: 100%;\n        z-index: theme.get-z-index(call-screen);\n    }\n\n    .header {\n        align-items: center;\n        background-color: theme.color(snow-50);\n        box-shadow: theme.box-shadow(md);\n        box-sizing: border-box;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        padding: theme.spacing(1, 2);\n        width: 100%;\n        z-index: 1;\n\n        @include theme.mq-down(sm) {\n            justify-content: flex-start;\n        }\n\n        .smHidden {\n            @include theme.mq-down(sm) {\n                display: none;\n            }\n        }\n\n        .iconBack {\n            display: none;\n\n            @include theme.mq-down(sm) {\n                display: initial;\n                font-size: 30px;\n            }\n        }\n\n        .timer {\n            @include theme.mq-down(sm) {\n                display: none;\n            }\n        }\n    }\n\n    .center {\n        align-items: center;\n        background-color: theme.color(snow-100);\n        box-sizing: border-box;\n        display: flex;\n        flex-grow: 1;\n        flex-wrap: wrap;\n        justify-content: center;\n        position: relative;\n        width: 100%;\n\n        .primaryVideo {\n            height: 100%;\n            position: absolute;\n            width: 100%;\n        }\n\n        .largeAvatarWithBorder {\n            border-color: theme.color(snow-50);\n        }\n    }\n\n    .secondaryVideos {\n        bottom: 0;\n        position: absolute;\n        right: theme.spacing(3);\n\n        > div {\n            @include small-video(146px, 104px);\n\n            margin-bottom: theme.spacing(3);\n        }\n\n        > div > video {\n            object-fit: contain;\n            position: relative;\n        }\n\n        > div.localPreview > video {\n            transform: scaleX(-1);\n        }\n    }\n\n    .panel {\n        align-items: center;\n        background-color: theme.color(snow-50);\n        box-shadow: theme.box-shadow(md);\n        box-sizing: border-box;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        padding: theme.spacing(1, 2);\n        position: relative;\n        width: 100%;\n        z-index: 1;\n\n        .toggleButton {\n            @include theme.typo(body3);\n\n            align-items: center;\n            color: theme.color(space-400);\n            display: flex;\n            flex-direction: column;\n            position: absolute;\n            right: theme.spacing(2);\n        }\n\n        .recordStopButton {\n            border-radius: 50%;\n        }\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:list';\n@use 'sass:map';\n\n$breakpoints: (\n    xs: 0,\n    sm: 600px,\n    md: 960px,\n    lg: 1280px,\n    xl: 1920px,\n);\n$breakpoint-keys: map.keys($breakpoints);\n$breakpoint-unit: px;\n$breakpoint-step: 0.05;\n\n@function breakpoint($breakpointName: xs) {\n    @return map.get($breakpoints, $breakpointName);\n}\n\n@mixin mq-up($breakpoint, $show-warning: true) {\n    @if map.has-key($breakpoints, $breakpoint) {\n        $index: list.index($breakpoint-keys, $breakpoint);\n\n        @if $index > 1 {\n            @media (min-width: map.get($breakpoints, $breakpoint)) {\n                @content;\n            }\n        } @else {\n            @content;\n\n            // stylelint-disable-next-line max-nesting-depth\n            @if $show-warning {\n                @warn 'Using #{$breakpoint} breakpoint as mq-up is redundant. Remove the media query.';\n            }\n        }\n    } @else {\n        @error 'Given breakpoint #{$breakpoint} is missing.';\n    }\n}\n\n@mixin mq-down($breakpoint) {\n    @if map.has-key($breakpoints, $breakpoint) {\n        $upper-index: list.index($breakpoint-keys, $breakpoint) + 1;\n\n        @if $upper-index == list.length($breakpoint-keys) + 1 {\n            $lowest-breakpoint-key: list.nth($breakpoint-keys, 1);\n\n            /* stylelint-disable-next-line max-line-length */\n            @warn 'Using #{$breakpoint} breakpoint as mq-down is redundant. Use mq-up(#{$lowest-breakpoint-key}) instead.';\n\n            @include mq-up($lowest-breakpoint-key, false) {\n                @content;\n            }\n        } @else {\n            $upper-breakpoint-key: list.nth($breakpoint-keys, $upper-index);\n\n            @media (max-width: map.get($breakpoints, $upper-breakpoint-key) - $breakpoint-step) {\n                @content;\n            }\n        }\n    } @else {\n        @error 'Given breakpoint #{$breakpoint} is missing.';\n    }\n}\n\n@mixin mq-between($start-breakpoint, $end-breakpoint, $show-warning: true) {\n    @if map.has-key($breakpoints, $start-breakpoint) and map.has-key($breakpoints, $end-breakpoint) {\n        $start-index: list.index($breakpoint-keys, $start-breakpoint);\n        $end-index: list.index($breakpoint-keys, $end-breakpoint);\n\n        @if $end-index == list.length($breakpoint-keys) {\n            @if $show-warning {\n                /* stylelint-disable-next-line max-line-length */\n                @warn 'Using #{$end-breakpoint} breakpoint as mq-betwen end is redundant. Use mq-up(#{$start-breakpoint}) instead.';\n            }\n\n            @include mq-up($start-breakpoint) {\n                @content;\n            }\n        } @else {\n            @if $start-index == $end-index {\n                @if $show-warning {\n                    @warn 'Start and end breakpoints are the same. Use mq-only(#{$start-breakpoint}) instead.';\n                }\n            } @else if $start-index > $end-index {\n                @if $show-warning {\n                    /* stylelint-disable-next-line max-line-length */\n                    @warn 'Start breakpoint (#{$start-breakpoint}) is bigger than end breakpoint (#{$end-breakpoint}). Remove it or change it.';\n                }\n            }\n\n            $upper-breakpoint: list.nth($breakpoint-keys, $end-index + 1);\n\n            @media\n                (min-width: map.get($breakpoints, $start-breakpoint)) and\n                (max-width: map.get($breakpoints, $upper-breakpoint) - $breakpoint-step) {\n                @content;\n            }\n        }\n    } @else {\n        @error 'Both or one of the given breakpoints (#{$start-breakpoint}, #{$end-breakpoint}) is missing.';\n    }\n}\n\n@mixin mq-only($breakpoint) {\n    @if map.has-key($breakpoints, $breakpoint) {\n        $index: list.index($breakpoint-keys, $breakpoint);\n\n        @if $index == list.length($breakpoint-keys) {\n            /* stylelint-disable-next-line max-line-length */\n            @warn 'Using #{$breakpoint} breakpoint as mq-only parameter is redundant. Use mq-up(#{$breakpoint}) instead.';\n\n            @include mq-up($breakpoint) {\n                @content;\n            }\n        } @else {\n            @include mq-between($breakpoint, $breakpoint, false) {\n                @content;\n            }\n        }\n    } @else {\n        @error 'Given breakpoint #{$breakpoint} is missing.';\n    }\n}\n\n@mixin mq($condition, $breakpoint-one, $breakpoint-two: null) {\n    @if ($condition == up) {\n        @include mq-up($breakpoint-one) {\n            @content;\n        }\n    } @else if ($condition == down) {\n        @include mq-down($breakpoint-one) {\n            @content;\n        }\n    } @else if ($condition == between) {\n        @include mq-between($breakpoint-one, $breakpoint-two) {\n            @content;\n        }\n    } @else if ($condition == only) {\n        @include mq-only($breakpoint-one) {\n            @content;\n        }\n    }\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'misc' as *;\n\n$typography-html-font-size: 14px;\n$typography-font-size: 14px;\n$typography-font-family: 'Inter',\n    system-ui,\n    -apple-system,\n    'Segoe UI',\n    'Roboto',\n    'Noto Sans',\n    'Ubuntu',\n    'Cantarell',\n    'Helvetica Neue';\n\n$typography-font-weights: (\n    regular: 400,\n    medium: 500,\n    bold: 700\n);\n\n$typography-variants: (\n    h1: 24px medium 34px -0.47px,\n    h2: 20px medium 30px -0.33px,\n    h3: 20px regular 30px -0.33px,\n    h4: 16px bold 24px -0.18px,\n    h5: 16px medium 24px -0.18px,\n    body1: 14px bold 20px -0.09px,\n    body2: 14px medium 20px -0.09px,\n    body3: 14px regular 20px -0.09px,\n    info1: 12px bold 18px 0.01px,\n    info2: 12px medium 18px 0.01px,\n    info3: 12px regular 18px 0.01px,\n);\n\n@function font-weight($weight: regular) {\n    @return map.get($typography-font-weights, $weight);\n}\n\n@function px2rem($value) {\n    @return math.div($value, $typography-html-font-size) * math.div($typography-font-size, 14px) * 1rem;\n}\n\n@mixin typo-by-values($font-size, $font-weight, $line-height, $letter-spacing) {\n    @include font-weight($font-weight);\n\n    font-size: px2rem($font-size);\n    letter-spacing: $letter-spacing;\n    line-height: $line-height;\n}\n\n@mixin font-weight($weight: regular, $important: false) {\n    font-weight: font-weight($weight) if-important($important);\n}\n\n@mixin typo($variant) {\n    $variant-values: map.get($typography-variants, $variant);\n\n    @include typo-by-values($variant-values...);\n\n    // TODO: remove this (if it was redundant) after the new typography replaced the old one\n    font-family: $typography-font-family;\n}\n\n@mixin truncate() {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__euCN0`,
	"ocean-50": `styles_ocean-50__4fCAC`,
	"ocean-100": `styles_ocean-100__iGVXc`,
	"ocean-200": `styles_ocean-200__Fk7Q3`,
	"ocean-300": `styles_ocean-300__X3TYE`,
	"ocean-400": `styles_ocean-400__sYyzG`,
	"ocean-500": `styles_ocean-500__IHn-k`,
	"ocean-600": `styles_ocean-600__ch42X`,
	"space-50": `styles_space-50__6nubT`,
	"space-100": `styles_space-100__pZOS9`,
	"space-200": `styles_space-200__cuXYE`,
	"space-300": `styles_space-300__94dMR`,
	"space-400": `styles_space-400__-pvL-`,
	"space-500": `styles_space-500__jLCWj`,
	"gray-50": `styles_gray-50__Bn40W`,
	"gray-100": `styles_gray-100__0o14M`,
	"gray-200": `styles_gray-200__qQKFc`,
	"gray-300": `styles_gray-300__iezEP`,
	"gray-400": `styles_gray-400__ls+ft`,
	"gray-500": `styles_gray-500__uUdGo`,
	"green-50": `styles_green-50__lVns0`,
	"green-100": `styles_green-100__RUBY8`,
	"green-200": `styles_green-200__LMK6u`,
	"green-300": `styles_green-300__sZJK1`,
	"green-400": `styles_green-400__RKwlr`,
	"green-500": `styles_green-500__ksQZh`,
	"red-50": `styles_red-50__fD5do`,
	"red-100": `styles_red-100__Mv+NG`,
	"red-200": `styles_red-200__WGXXh`,
	"red-300": `styles_red-300__E2ben`,
	"red-400": `styles_red-400__9fQXs`,
	"red-500": `styles_red-500__SOboz`,
	"yellow-50": `styles_yellow-50__PSwy8`,
	"yellow-100": `styles_yellow-100__e1pD2`,
	"yellow-200": `styles_yellow-200__KDpT8`,
	"yellow-300": `styles_yellow-300__QnN3C`,
	"yellow-400": `styles_yellow-400__vtvaL`,
	"yellow-500": `styles_yellow-500__Hovlr`,
	"orange-50": `styles_orange-50__Oy4Kc`,
	"orange-100": `styles_orange-100__UZgjC`,
	"orange-200": `styles_orange-200__PpT3B`,
	"orange-300": `styles_orange-300__JBw7o`,
	"orange-400": `styles_orange-400__7C0-v`,
	"orange-500": `styles_orange-500__0HqcN`,
	"turquoise-50": `styles_turquoise-50__DV7Wx`,
	"turquoise-100": `styles_turquoise-100__vh5XI`,
	"turquoise-200": `styles_turquoise-200__NUnDv`,
	"turquoise-300": `styles_turquoise-300__4o8it`,
	"turquoise-400": `styles_turquoise-400__jTXZ8`,
	"turquoise-500": `styles_turquoise-500__LmPjy`,
	"turquoise-600": `styles_turquoise-600__wDhj7`,
	"violet-50": `styles_violet-50__0yyLn`,
	"violet-100": `styles_violet-100__0Jq9L`,
	"violet-200": `styles_violet-200__JtQAK`,
	"violet-300": `styles_violet-300__ELPe1`,
	"violet-400": `styles_violet-400__vmGjW`,
	"violet-500": `styles_violet-500__UtriA`,
	"snow-50": `styles_snow-50__3esHl`,
	"snow-100": `styles_snow-100__1CjcL`,
	"snow-200": `styles_snow-200__WMB7L`,
	"snow-300": `styles_snow-300__gWajE`,
	"snow-400": `styles_snow-400__gejV5`,
	"snow-500": `styles_snow-500__brwBZ`,
	"background-color": `styles_background-color__-bg0K`,
	"ocean": `styles_ocean__Kxc82`,
	"ocean-light": `styles_ocean-light__o-0UQ`,
	"green": `styles_green__YYOX0`,
	"green-light": `styles_green-light__nYHul`,
	"red": `styles_red__NErzb`,
	"red-light": `styles_red-light__Ffq-6`,
	"orange": `styles_orange__j2bv9`,
	"orange-light": `styles_orange-light__LgHQM`,
	"space": `styles_space__+w17E`,
	"space-light": `styles_space-light__Re++8`,
	"gray-light": `styles_gray-light__Y0mNm`,
	"violet": `styles_violet__4+E8l`,
	"violet-light": `styles_violet-light__z20f9`,
	"yellow": `styles_yellow__qIqPY`,
	"yellow-light": `styles_yellow-light__bgZXf`,
	"root": `styles_root__QxD9S`,
	"buttons": `styles_buttons__XJbmw`,
	"videoBackground": `styles_videoBackground__yfY35`,
	"visible": `styles_visible__OSZ3M`,
	"draggable": `styles_draggable__HGaAv`,
	"recordingIndicator": `styles_recordingIndicator__aW8LJ`,
	"header": `styles_header__Yr2vi`,
	"minimizedVideo": `styles_minimizedVideo__tX-uU`,
	"wrapper": `styles_wrapper__lMcwb`,
	"draggableFirstButtons": `styles_draggableFirstButtons__j+F7W`,
	"rootActive": `styles_rootActive__kqlXV`,
	"smHidden": `styles_smHidden__-7pcg`,
	"iconBack": `styles_iconBack__nsul8`,
	"timer": `styles_timer__7kEEh`,
	"center": `styles_center__2lTbX`,
	"primaryVideo": `styles_primaryVideo__cDLdu`,
	"largeAvatarWithBorder": `styles_largeAvatarWithBorder__QiJXk`,
	"secondaryVideos": `styles_secondaryVideos__RVR8S`,
	"localPreview": `styles_localPreview__ch-mM`,
	"panel": `styles_panel__6eWuf`,
	"toggleButton": `styles_toggleButton__PLNKX`,
	"recordStopButton": `styles_recordStopButton__PWPly`
};
export default ___CSS_LOADER_EXPORT___;
